import IconButton from '@material-ui/core/IconButton';
import { useState } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import styled from 'styled-components';

import ProfileImage from '../common/avatar/ProfileImage';

import CandidatePopover from './CandidatePopover';

import { Candidate_me } from './__generated__/Candidate_me.graphql';

const Container = styled.div`
  box-sizing: border-box;
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
`;

type Props = {
  me: Candidate_me;
};
const Candidate = ({ me }: Props) => {
  const [popoverAnchor, setPopoverAnchor] = useState(null);

  const openPopover = (anchorEl) => {
    setPopoverAnchor(anchorEl);
  };

  const closePopover = () => {
    setPopoverAnchor(null);
  };

  const togglePopover = (event) => {
    if (popoverAnchor) {
      closePopover();
    } else {
      openPopover(event.currentTarget);
    }
  };

  if (!me) {
    return null;
  }

  const { profileImage } = me;

  return (
    <Container>
      <IconButton onClick={togglePopover} data-testid="profile-button">
        <ProfileImage size={50} profileImage={profileImage?.url} />
      </IconButton>
      <CandidatePopover
        me={me}
        profileImage={profileImage?.url}
        close={closePopover}
        anchorEl={popoverAnchor}
        open={!!popoverAnchor}
      />
    </Container>
  );
};

export default createFragmentContainer(Candidate, {
  me: graphql`
    fragment Candidate_me on Candidate {
      id
      name
      email
      profileImage {
        url(height: 50, width: 50)
      }
    }
  `,
});
